/**!
 * Cursor.js v2.0.1
 * @author phucbm
 * @homepage https://github.com/phucbm/cursorjs
 * @license MIT 2023
 */
! ( function( e, o ) {
	if ( 'object' === typeof exports && 'object' === typeof module ) {
		module.exports = o();
	} else if ( 'function' === typeof define && define.amd ) {
		define( [], o );
	} else {
		const r = o(); for ( const s in r ) {
			( 'object' === typeof exports ? exports : e )[ s ] = r[ s ];
		}
	}
}( this, ( () => ( () => {
	'use strict'; const e = { r: ( e ) => {
			'undefined' !== typeof Symbol && Symbol.toStringTag && Object.defineProperty( e, Symbol.toStringTag, { value: 'Module' } ), Object.defineProperty( e, '__esModule', { value: ! 0 } );
		} },
		o = {}; function r( e = '' ) {
		return e + ( +new Date ).toString( 16 ) + ( 1e8 * Math.random() | 0 ).toString( 16 );
	} function s( e, o, r ) {
		e.mouse.x = o, e.mouse.y = r, 'function' === typeof e.config.onUpdate && e.config.onUpdate( { mouse: e.mouse } );
	} function n( e ) {
		! ( function( e ) {
			document.addEventListener( 'mouseout', ( ( o ) => {
				e.config.dev && console.log( 'doc out' ), e.cursorWrapper.classList.remove( e._class.inViewport ), e.cursorInner.style.opacity = '0';
			} ) ), document.addEventListener( 'mouseover', ( ( o ) => {
				e.config.dev && console.log( 'doc in' ), e.cursorWrapper.classList.add( e._class.inViewport ), e.cursorInner.style.opacity = '1';
			} ) ), window.addEventListener( 'mousemove', ( ( o ) => {
				s( e, o.x, o.y );
			} ) );
		}( e ) ), t( e );
	} function t( e ) {
		for ( const o of e.config.hover ) {
			document.querySelectorAll( o.selectors + `:not(${ e._class.hoverEnabled })` ).forEach( ( ( r ) => {
				r.classList.add( e._class.hoverEnabled ), r.style.cursor = o.cursor ? o.cursor : 'none'; const s = e.config.hoverPrefixClass + o.className; r.addEventListener( 'mouseenter', ( ( o ) => {
					e.cursorWrapper.classList.add( s ), e.cursorWrapper.classList.add( e._class.isHover );
				} ) ), r.addEventListener( 'mouseleave', ( ( o ) => {
					e.cursorWrapper.classList.remove( s ), e.cursorWrapper.classList.remove( e._class.isHover );
				} ) );
			} ) );
		}
	}e.r( o ); class i {
		constructor( e ) {
			this.config = { dev: ! 1, id: r( 'css-cursor-' ), speed: .2, container: document.body, className: '', innerHTML: '', classInViewport: '', matchMedia: '(hover:hover)', wrapperCSS: {}, cursorCSS: {}, hoverPrefixClass: '', hover: [], onUpdate: ( e ) => {}, ...e }, window.matchMedia( this.config.matchMedia ).matches ? this.config.container ? ( this._style = { wrapperCSS: { pointerEvents: 'none', zIndex: '9999', position: 'fixed', top: 0, left: 0 }, cursorCSS: { boxShadow: '0 0 0 2px rgba(0, 0, 0, .3)', width: '40px', height: '40px', borderRadius: '50%', transition: 'all .3s ease', position: 'absolute', transform: 'translate(-50%,-50%)' } }, this.config.wrapperCSS = { ...this._style.wrapperCSS, ...this.config.wrapperCSS }, this.config.cursorCSS = { ...this._style.cursorCSS, ...this.config.cursorCSS }, this._class = { wrapper: 'css-cursor', inner: 'css-cursor-inner', isHover: 'is-hover', hoverEnabled: 'css-cursor-hover-enabled', inViewport: this.config.classInViewport || 'in-viewport' }, this.id = this.config.id, this.mouse = { x: 0, y: 0 }, this.cursorWrapper = void 0, this.cursorInner = void 0, ( function( e ) {
				const o = `<div id="${ e.id }" class="${ e._class.wrapper } ${ e.config.className }">\n                    <div class="${ e._class.inner }">${ e.config.innerHTML }</div>\n                  </div>`; e.config.container.insertAdjacentHTML( 'beforeend', o ), e.cursorWrapper = document.querySelector( `#${ e.id }` ), e.cursorInner = e.cursorWrapper.firstElementChild, Object.assign( e.cursorWrapper.style, e.config.wrapperCSS ), Object.assign( e.cursorInner.style, e.config.cursorCSS ), e.config.dev && console.log( `cursor created #${ e.id }` );
			}( this ) ), ( function( e ) {
				const o = { x: window.innerWidth, y: window.innerHeight }; s( e, o.x, o.y ); const r = () => {
					'none' !== getComputedStyle( e.cursorWrapper ).display && ( o.x += ( e.mouse.x - o.x ) * e.config.speed, o.y += ( e.mouse.y - o.y ) * e.config.speed, e.cursorWrapper.style.transform = `translate(${ o.x }px,${ o.y }px)` ), requestAnimationFrame( r );
				}; r();
			}( this ) ), n( this ) ) : console.warn( 'Container is not defined!', this.config.container ) : this.config.dev && console.log( `Cursor ${ this.config.id } not init due to unmatched media`, this.config.matchMedia );
		}update( e ) {
			this.config = { ...this.config, ...e };
		}destroy() {
			this.cursorWrapper.remove(), window.CursorjsController.remove( this.id ), this.config.dev && console.log( `cursor #${ this.id } removed` );
		}refresh() {
			t( this );
		}
	} return window.CursorjsController = new class {
		constructor() {
			this.instances = [];
		}remove( e ) {
			this.instances = this.instances.filter( ( ( o ) => o.id !== e ) );
		}add( e ) {
			this.instances.push( e );
		}get( e ) {
			return this.instances.filter( ( ( o ) => o.id === e ) )[ 0 ];
		}
	}, window.Cursorjs = { create: ( e = {} ) => window.CursorjsController.add( new i( e ) ), get: ( e ) => window.CursorjsController.get( e ) }, o;
} )() ) ) );
